// extracted by mini-css-extract-plugin
module.exports = {"wrap":"styles-module--wrap--26DyL","heading":"styles-module--heading--7VnHh","list":"styles-module--list--NtlrN","button":"styles-module--button--qf6OY"};